import { closeAlert as closeAlertService } from '../api/services/Alerts';
import { useToast } from '../contexts/ToastContext';

interface UseCloseHook {
  closeAlert: (id: number, reasonKey: string, userId: number) => Promise<boolean>;
}

export const useClose = (): UseCloseHook => {
  const { addToast } = useToast();

  const closeAlert = async (id: number, reasonKey: string, userId: number) => {
    const response = await closeAlertService(id, reasonKey, userId);
    let success = false;

    if (response.type === 'error') {
      response.error.errors.forEach((error) => addToast({ severity: 'error', message: error }));
    } else {
      response.data.messages.forEach((message) => addToast({ severity: 'success', message }));
      success = true;
    }

    return success;
  };

  return { closeAlert };
};
